/**
 * mcycle homepage select list(category & brand)
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/8
 */
import './index.css';
import React, { Component } from 'react';
import SelectItem from './selectItem';

class SelectList extends Component {
  render() {
    return (
      <div className="mcycle-home-select-list">
        {/* category list */}
        <SelectItem type="category" title="品类" data={ this.props.category } />

        {/* brand list */}
        <SelectItem type="brand" title="品牌" data={ this.props.brand } />
      </div>
    )
  }
}

export default SelectList



// WEBPACK FOOTER //
// ./src/components/home/selectList/index.js